import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createUserAction } from '../../../redux/actions/usersActions';
import Button from '../../shared/buttons/Button';
import CommonLoader from '../../shared/loaders/CommonLoader';
import Modal from '../../shared/modal/Modal';
import UserCreateForm from '../forms/UserCreateForm';

const CreateUserModal = ({ onModalClose, onModalSubmit }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const roles = useSelector((state) => state.roles.roles);

  const onSubmit = async (data) => {
    setLoading(true);
    await dispatch(createUserAction(data));
    setLoading(false);
    onModalSubmit();
  };

  return (
    <Modal
      title={'Додати користувача'}
      loading={loading}
      onClose={onModalClose}
      body={
        loading ? (
          <CommonLoader />
        ) : (
          <UserCreateForm roles={roles} readOnly={false} onSubmit={onSubmit} loading={loading} />
        )
      }
      actionButton={
        <Button type={'submit'} disabled={loading} variant={'primary'} formId={'user-form'} children={'Зберегти'} />
      }
    />
  );
};

export default CreateUserModal;
